<template>
  <ModalUi @closeModal="toggleModals">
    <div class="modal-wrap">
      <div class="modal-block">
        <div class="modal-title">
          <h3>Выбрать шаблон или черновик доставки</h3>
        </div>
        <button class="close" type="button" @click="toggleModals()">
          <img src="/images/redesignedForm/close-button.svg" alt="close" />
        </button>
        <hr class="line" />
        <div v-if="base.isEdit" class="alert">Шаблоны недоступны в процессе редактирования.</div>
        <div class="modal-content">
          <ul class="templates">
            <li
              v-for="template in allItems[page]"
              :key="template.tid"
              class="template"
              @click="selectTemplate(template)"
              @keypress="selectTemplate(template)"
              :disabled="base.isEdit"
              :class="{
                selected: selectedTemplate && template.tid === selectedTemplate.tid,
                disabled: base.isEdit,
              }"
            >
              <span>{{ template.alias }}</span>
              <span style="color: red">
                {{ template.type !== undefined ? '' : 'черновик' }}
              </span>
              <button
                class="delete-template"
                @click="deleteTemplate($event, template)"
                type="button"
              >
                <img src="/images/redesignedForm/close-button.svg" alt="close" />
              </button>
            </li>
          </ul>
          <hr class="line" v-if="allItems.length" />
          <div v-if="allItems.length" class="pagination">
            <button class="arrow left" @click="page > 0 ? page-- : null">
              <img src="/images/redesignedForm/arrow-left.svg" alt="arrow" />
            </button>
            <span>{{ page + 1 }} из {{ pageCount }}</span>
            <button class="arrow right" @click="page < pageCount - 1 ? page++ : null">
              <img src="/images/redesignedForm/arrow-right-p.svg" alt="arrow" />
            </button>
          </div>
          <div class="message" v-else>
            У вас пока нет сохраненных шаблонов. Вы можете создать шаблон из завершенного заказа на
            странице списка заказов, либо cоздать черновик на основе данной формы.
          </div>
          <div class="back-wrap">
            <button
              class="back"
              v-if="width < 992"
              type="button"
              @click="toggleModals('createNewTemplate')"
            >
              Создать черновик
            </button>
          </div>
        </div>
      </div>
    </div>
  </ModalUi>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'
import qs from 'qs'
import OrderService from '@services/order/api'
import paginationMixin from '@apps/order-form/src/mixins/pagination'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import ModalUi from '@features/UI/ModalUi.vue'
import useWindowWidth from '@/hooks/useWindowWidth'

export default {
  name: 'TemplatesModal',
  components: { ModalUi },
  mixins: [paginationMixin],
  data: () => ({
    width: 0,
    windowWidthListener: null,
  }),
  computed: {
    ...mapState(GENERAL_STORE, ['base', 'form', 'selectedTemplate']),
    ...mapGetters(GENERAL_STORE, ['templates']),
  },
  methods: {
    ...mapMutations(GENERAL_STORE, [
      'toggleModals',
      'setSelectedTemplate',
      'deleteTemplateLocal',
      'setWarningMessage',
    ]),
    ...mapActions(GENERAL_STORE, ['setDeliveryObject']),

    async selectTemplate(targetTemplate) {
      if (this.base.isEdit) return

      this.setSelectedTemplate(targetTemplate)

      try {
        const template = await this.getTemplate(targetTemplate)

        if (template?.alias) {
          this.setDeliveryObject({
            template: qs.parse(template.json_draft),
            isAlias: true,
          })
        } else {
          this.setDeliveryObject({ template, isAlias: false })
        }
      } catch (e) {
        this.setWarningMessage({
          body: e.message,
        })
        this.toggleModals('warningMessage')
      }
    },

    async getTemplate(template) {
      const templateType = typeof template?.type !== 'undefined'

      if (templateType) {
        const response = await OrderService.getOrderTemplate({
          orderId: template.oid,
          templateType,
        })

        return response.template
      }

      const response = await OrderService.getDraft({
        tid: template.tid,
      })

      return response.template
    },

    async deleteTemplate(e, template) {
      e.stopPropagation()

      const requestData = { id: template.tid }

      try {
        if (typeof template?.type !== 'undefined')
          await OrderService.deleteOrderTemplate(requestData)
        else await OrderService.deleteOrderDraft(requestData)

        this.deleteTemplateLocal(template.tid)

        const idx = this.allItems.flat().findIndex(tmp => tmp.tid === template.tid)

        this.items.findIndex(tmp => tmp.tid)

        if (idx > -1) {
          this.items.splice(idx, 1)
          this.setupPagination(this.templates)
        }
      } catch (error) {
        this.setWarningMessage({
          body: error.message,
        })
        this.toggleModals('warningMessage')
      }
    },
  },

  mounted() {
    this.windowWidthListener = useWindowWidth(width => {
      this.width = width
    })
    this.setupPagination(this.templates)
  },
  beforeUnmount() {
    if (this.windowWidthListener) this.windowWidthListener.remove()
  },
}
</script>

<style scoped lang="scss">
.message {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 10px;

  line-height: 24px;
  text-align: center;
}

.selected {
  background-color: #dbe0e4;
}

.disabled {
  opacity: 0.4;
}

.alert {
  padding: 10px;

  color: red;
  text-align: center;
}
</style>
